<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>选题</el-breadcrumb-item>
        <el-breadcrumb-item>账号管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">账号管理</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="createDialog = true"
          >创建</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item label="账号名称">
          <el-input
            v-model.trim="query.name_keyword"
            placeholder="输入账号名称"
            @input="fetchList(true)"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="院校学科">
          <el-input
            v-model.trim="query.college_major_keyword"
            placeholder="输入院校学科"
            @input="fetchList(true)"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="所属平台">
          <el-select
            v-model="query.platform_codes"
            clearable
            placeholder="请选择"
            style="width: 350px"
            @input="fetchList(true)"
          >
            <el-option
              label="小红书"
              :value="1"
            ></el-option>
            <el-option
              label="公众号"
              :value="2"
            ></el-option>
            <el-option
              label="微博"
              :value="3"
            ></el-option>
            <!--  <el-option
              label="B站"
              :value="4"
            ></el-option> -->
            <el-option
              label="知乎"
              :value="5"
            ></el-option>
            <!--     <el-option
              label="抖音"
              :value="6"
            ></el-option> -->
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">账号列表</h3>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="50"
          > </el-table-column>
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="类型"
            width="100"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{formateType_code(scope.row.type_code)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="账号名称"
            width="160"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            label="院校学科"
            width="260"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.college_name?scope.row.college_name:""}}
              {{scope.row.college_name&&scope.row.major_name?"/":""}}
              {{scope.row.major_code?`(${scope.row.major_code})${scope.row.major_name}`:""}}
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="院校"
            width="260"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.college_name?scope.row.college_name:"/"}}
            </template>
          </el-table-column>
          <el-table-column
            label="学科"
            width="260"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.major_name?`(${scope.row.major_code})${scope.row.major_name}`:"/"}}
            </template>
          </el-table-column> -->

          <el-table-column
            label="所属平台"
            width="100"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{formatePlatform_code(scope.row.platform_code)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="daily_require_count"
            label="每日要求"
            width="80"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="topic_count"
            label="选题数量"
            width="80"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="ready_publish_count"
            label="待发文案"
            width="80"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="today_publish_count"
            label="今日发布"
            width="80"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="total_publish_count"
            label="累计发布"
            width="80"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            width="120"
            label="创建人"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ formateCreator(scope.row.creator)}}
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="修改时间"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY.MM.DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="200"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="openEditDialog(scope.row)"
              >编辑</el-link>
              <el-link
                type="danger"
                :underline="false"
                @click="handleToRemove(scope.row.id)"
              >删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-button
          size="small"
          type="danger"
          @click="handleToDeleteAll()"
        >批量删除</el-button>
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <AccountCreate
      :visible="createDialog"
      @close="createDialog=false"
      @submit="fetchList"
    />
    <AccountEdit
      :visible="editDialog"
      @close="editDialog=false"
      @submit="fetchList"
      :content="editContent"
    />
  </div>
</template>

<script>

import { mediaaccountlist, mediaaccountDestroy, mediaaccountlistDestroy } from "@/api/select";
import AccountCreate from "@/components/dialog/select/AccountCreate";
import AccountEdit from "@/components/dialog/select/AccountEdit";



export default {
  components: {
    AccountEdit,
    AccountCreate
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      createDialog: false,
      editDialog: false,
      editContent: {},
      chooseList: [],
    };
  },
  created() {
    this.fetchList()
    this.$store.dispatch("getAllColleges");
    this.$store.dispatch('getAdminList')
  },
  methods: {
    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }
      const params = Object.assign({}, this.query);

      mediaaccountlist(params).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
      if (this.query.platform_codes) {
        this.query.platform_codes = this.query.platform_codes.split(",");
      }
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query);
      if (params.platform_codes) {
        params.platform_codes = params.platform_codes.filter((v) => v).join(",");
      }
      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        });
    },
    handleToRemove(id) {
      this.$confirm("确定要删除此条信息吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        mediaaccountDestroy({ id }).then((res) => {
          this.$nextTick(() => {
            this.fetchList();
          });
        });
      })
    },
    formatePlatform_code(val) {
      const platform_code = {
        1: "小红书",
        2: "公众号",
        3: "微博",
        /*     4: "B站", */
        5: "知乎",
        /*      6: "抖音" */
      };
      return platform_code[val] || "";
    },
    formateType_code(val) {
      const type_code = {
        1: "机构",
        2: "课程",
        3: "学科",
        4: "院校",
      };
      return type_code[val] || "";
    },
    openEditDialog(row) {
      this.editDialog = true
      this.editContent = Object.assign({}, row)
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleToDeleteAll() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      this.$confirm("确定要删除这些信息吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = this.chooseList.map(v => { return v.id })
        mediaaccountlistDestroy({ ids }).then((res) => {
          this.fetchList();
        });
      })
    },
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (this.$store.state.adminList.findIndex((v) => { return v.id == val }) > -1) {
            return this.$store.state.adminList.find((v) => { return v.id == val }).nickname
          } else {
            return "无"
          }
        } else {
          return "无"
        }
      }
    },

  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
</style>
